import { render, staticRenderFns } from "./TurnieranmeldungUebersicht.vue?vue&type=template&id=51e084d2&scoped=true&"
import script from "./TurnieranmeldungUebersicht.vue?vue&type=script&lang=js&"
export * from "./TurnieranmeldungUebersicht.vue?vue&type=script&lang=js&"
import style0 from "./TurnieranmeldungUebersicht.vue?vue&type=style&index=0&id=51e084d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e084d2",
  null
  
)

export default component.exports